<template>
  <div class="dashboard">
    <div class="navbar">
      <span v-for="component,key in components" :key="component" @click="index = key; setPage()">{{component}}</span>
    </div>
    <component :is="page"></component>
  </div>
</template>

<script>

import Relevant from './Relevant';
import Notes from './Notes';
import Daily from './Daily';
import Weekly from './Weekly'
import Deadline from './Deadline';
import Date from './Date';

export default {
    name: 'Dashboard',
    components: {
      relevant: Relevant,
      notes: Notes,
      daily: Daily,
      weekly: Weekly,
      deadline: Deadline,
      date: Date
    },
    data() {
      return {
        page: localStorage.getItem('page') || 'notes',
        components: ['relevant', 'notes', 'date', 'daily', 'weekly', 'deadline'],
        startX: 0,
        index: parseInt(localStorage.getItem('page_index')) || 0
      }
    },
    methods: {
      setPage() {
        this.page = this.components[this.index];
        
        localStorage.setItem('page', this.page);
        localStorage.setItem('page_index', this.index)
      },
      swipeLeft() {
        this.index -= 1;

        if (this.index < 0) this.index = this.components.length - 1;

        this.setPage();
      },
      swipeRight() {
        this.index += 1;

        if (this.index === this.components.length) this.index = 0;

        this.setPage();
      }
    },
    mounted() {
      this.$el.addEventListener('touchstart', (e) => {
        this.startX = e.changedTouches[0].clientX;
      })
      this.$el.addEventListener('touchend', (e) => {
        const distance = e.changedTouches[0].clientX - this.startX;

        if (distance < 150 && distance > -150) return;

        if (distance < 0) this.swipeRight();
        else this.swipeLeft();
      })
    }
}
</script>

<style scoped>

.dashboard {
  padding: 10px;
  height: calc(100% - 20px);
}

.navbar {
  display: none;
}

@media (min-width: 1000px) {
  .navbar {
    display: block;
  }
}

</style>


// WEBPACK FOOTER //
// src/components/Dashboard.vue